<script setup>
import { useGetTranslation, useRouter, useStore } from "@/components/Utils/functions";
import apiCall from "@/utils/api";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ref } from "vue";
import Form from "./Form.vue";

const store = useStore();
const router = useRouter();
const t = useGetTranslation();

const permissionModel = ref({});
const form = ref(null);

const createPermissionMtn = useMutation({
  mutationFn: async () => {
    await apiCall({
      url: "/api/permission",
      method: "POST",
      data: permissionModel.value,
    });
  },
});

const queryClient = useQueryClient();
const onFormSubmitted = async () => {
  const formInvalid = !form.value.validate();
  if (formInvalid) {
    return;
  }
  await createPermissionMtn.mutateAsync();
  queryClient.invalidateQueries({
    queryKey: ["listPermissions"],
  });
  store.commit("openSnackbar", {
    open: true,
    text: t("permissionCreatedMsg"),
    color: "success",
  });
  router.back();
};
</script>
<template>
  <v-container class="mt-10">
    <v-row>
      <v-col>
        <v-form ref="form" @submit.prevent="onFormSubmitted">
          <Form
            :performingCrud="createPermissionMtn.isLoading.value"
            :model="permissionModel"
            :title="$t('createUserMessage')"
          />
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
